// extracted by mini-css-extract-plugin
export var actionIcon = "_tg-0";